import { AppState } from "store/AppState"

export const selectTemplatePreviewHtmlPending = (s: AppState) =>
  s.template.templatePreviewHtml.pending
export const selectTemplatePreviewHtmlFetchError = (s: AppState) =>
  s.template.templatePreviewHtml.error

export const selectTemplatePreviewHtml = (s: AppState) =>
  s.template.templatePreviewHtml.data || ""
